exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".settingsSidebar ul{margin:0 50px 0 0;padding:0;list-style:none}.settingsSidebar li{margin:0 0 1px}.settingsSidebar a{display:block;padding:10px 15px;color:#373737}.settingsSidebar a.active,.settingsSidebar a:hover{background-color:#f3f3f3}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/components/common/PageLayout/Setting/sidebar.scss
// module id = 1020
// module chunks = 0